import { applyAddNodeChange, getAddNodeInverseAction, IAddNodeAction } from "./actions/node/addNode";
import {
  applyDeleteNodeChange,
  getDeleteNodeInverseAction,
  IDeleteNodeAction,
} from "./actions/node/deleteNode";
import {
  applyMoveElementChange,
  getMoveElementInverseAction,
  IMoveElementAction,
} from "./actions/element/moveElement";
import { ISelectNodeAction } from "./actions/node/selectNode";
import { IUpdateSelectedNodeAction } from "./actions/node/updateSelectedNode";
import { IWebsiteBuilderRoot } from "pages/secure/facility/websiteBuilder/editor/nodes/root/websiteBuilderRoot";
import {
  applyResizeElementChange,
  getResizeElementInverseAction,
  IResizeElementAction,
} from "./actions/element/resizeElement";
import {
  applyUpdateElementSettingsChange,
  getUpdateElementSettingsInverseAction,
  IUpdateElementSettingsAction,
} from "./actions/element/updateElementSettings";
import {
  applyMoveSectionChange,
  getMoveSectionInverseAction,
  IMoveSectionAction,
} from "./actions/section/moveSection";
import {
  applyResizeSectionChange,
  getResizeSectionInverseAction,
  IResizeSectionAction,
} from "./actions/section/resizeSection";
import {
  applyBringToFrontElementChange,
  getBringToFrontElementInverseAction,
  IBringToFrontElementAction,
} from "./actions/element/bringToFrontElement";
import {
  applyBringToBackElementChange,
  getBringToBackElementInverseAction,
  IBringToBackElementAction,
} from "./actions/element/bringToBackElement";
import {
  applyUpdateElementStretchChange,
  getUpdateElementStretchInverseAction,
  IUpdateElementStretchAction,
} from "./actions/element/updateElementStretch";
import { ISelectThemeAction } from "./actions/themes/selectThemeAction";
import { IUpdateGlobalStylesAction } from "./actions/globalStyles/updateGlobalStyles";
import { ISetModeAction } from "./actions/mode/setMode";
import { IExitEditorAction } from "./actions/lifecycle/exitEditor";
import { ILoadEditorAction } from "./actions/lifecycle/loadEditor";
import { IStartLoadingEditorAction } from "./actions/lifecycle/startLoadingEditor";
import { IAddIconAssetsAction } from "./actions/icon/addIconAssets";
import { IPostMediaItemAction } from "./actions/media/postMediaItem";
import { IUpdateAutoSaveStatusStateAction } from "./actions/autoSave/updateAutoSaveStatusState";
import { IUndoAction } from "./actions/history/undo";
import { IRedoAction } from "./actions/history/redo";
import { IArchiveMediaItemAction } from "./actions/media/archiveMediaItem";
import { IRestoreMediaItemAction } from "./actions/media/restoreMediaItem";
import { IPublishWebsiteVersionAction } from "./actions/publish/publishWebsiteVersion";
import { applyUpdateSectionBackgroundChange, getUpdateSectionBackgroundInverseAction, IUpdateSectionBackgroundAction } from "./actions/section/updateSectionBackground";
import { applyUpdateHeaderChange, getUpdateHeaderInverseAction, IUpdateHeaderAction } from "./actions/section/updateHeader";
import { IRestoreWebsiteVersionAction } from "./actions/restore/restoreWebsiteVersion";
import { AnyAction } from "redux";
import { IWebsiteBuilderHeader } from "pages/secure/facility/websiteBuilder/editor/nodes/section/websiteBuilderHeader";
import { IWebsiteBuilderFooter } from "pages/secure/facility/websiteBuilder/editor/nodes/section/websiteBuilderFooter";
import { ISelectPageAction } from "./actions/page/selectPage";
import { TWebsiteBuilderWebsiteVersionPage } from "redux/reducers/models/websiteBuilder";
import { IWebsiteBuilderEditor } from "redux/reducers/websiteBuilder/websiteBuilderEditor";
import { IAddPageAction } from "./actions/page/addPage";
import { IDeletePageAction } from "./actions/page/deletePage";
import { IRenamePageAction } from "./actions/page/renamePage";
import { applyUpdateContainerSettingsChange, getUpdateContainerSettingsInverseAction, IUpdateContainerSettingsAction } from "./actions/container/updateContainerSettings";
import { ISetHomePageAction } from "./actions/page/setHomePage";
import { IReorderNavigationMenuItemsAction } from "./actions/navigationMenuItems/reorderNavigationMenuItems";
import { IUpdateNavigationMenuItemAction } from "./actions/navigationMenuItems/updateNavigationMenuItem";
import { IAddNavigationMenuItemAction } from "./actions/navigationMenuItems/addNavigationMenuItem";
import { IDeleteNavigationMenuItemAction } from "./actions/navigationMenuItems/deleteNavigationMenuItem";
import { applyUpdateContainerStretchChange, getUpdateContainerStretchInverseAction, IUpdateContainerStretchAction } from "./actions/container/updateContainerStretch";
import { applyBringToFrontContainerChange, getBringToFrontContainerInverseAction, IBringToFrontContainerAction } from "./actions/container/bringToFrontContainer";
import { applyBringToBackContainerChange, getBringToBackContainerInverseAction, IBringToBackContainerAction } from "./actions/container/bringToBackContainer";
import { applyResizeContainerChange, getResizeContainerInverseAction, IResizeContainerAction } from "./actions/container/resizeContainer";
import { applyMoveContainerChange, getMoveContainerInverseAction, IMoveContainerAction } from "./actions/container/moveContainer";
import { applySwapFlexChildChange, getSwapFlexChildInverseAction, ISwapFlexChildAction } from "./actions/container/swapFlexChild";
import { applySwapGridCellContentChange, getSwapGridCellContentInverseAction, ISwapGridCellContentAction } from "./actions/container/swapGridCellContent";
import { applyAddTabChange, getAddTabInverseAction, IAddTabAction } from "./actions/tab/addTab";
import { applyDeleteTabChange, getDeleteTabInverseAction, IDeleteTabAction } from "./actions/tab/deleteTab";
import { applySwapTabChange, getSwapTabInverseAction, ISwapTabAction } from "./actions/tab/swapTab";
import { applyUpdateTabSettingsChange, getUpdateTabSettingsInverseAction, IUpdateTabSettingsAction } from "./actions/tab/updateTabSettings";
import { ISetDeviceViewAction } from "./actions/deviceView/setDeviceView";
import { ISetFatalErrorAction } from "./actions/error/setFatalError";
import { TWebsiteBuilderDevice } from "pages/secure/facility/websiteBuilder/editor/website/shared/device";
import { applySetHideableNodeVisibilityChange, getSetHideableNodeVisibilityInverseAction, ISetHideableNodeVisibilityAction } from "./actions/visibility/setHideableNodeVisibility";
import { IAddFormAction } from "./actions/form/addForm";
import { IArchiveFormAction } from "./actions/form/archiveForm";
import { IUpdateFormAction } from "./actions/form/updateForm";
import { IUpdateFormNameAction } from "./actions/form/updateFormName";
import {
  applyUpdateGridDimensionsChange,
  getUpdateGridDimensionsInverseAction,
  IUpdateGridDimensionsAction,
} from "./actions/container/updateGridDimensions";

export const WebsiteBuilderEditorActionType = {
  START_LOADING_EDITOR: "websiteBuilderEditor.START_LOADING_EDITOR",
  LOAD_EDITOR: "websiteBuilderEditor.LOAD_EDITOR",
  EXIT_EDITOR: "websiteBuilderEditor.EXIT_EDITOR",
  SET_FATAL_ERROR: "websiteBuilderEditor.SET_FATAL_ERROR",
  UPDATE_AUTO_SAVE_STATUS_STATE: "websiteBuilderEditor.UPDATE_AUTO_SAVE_STATUS_STATE",
  SET_DEVICE_VIEW: "websiteBuilderEditor.SET_DEVICE_VIEW",
  SET_MODE: "websiteBuilderEditor.SET_MODE",
  PUBLISH_WEBSITE_VERSION: "websiteBuilderEditor.PUBLISH_WEBSITE_VERSION",
  RESTORE_WEBSITE_VERSION: "websiteBuilderEditor.RESTORE_WEBSITE_VERSION",
  SELECT_PAGE: "websiteBuilderEditor.SELECT_PAGE",
  ADD_PAGE: "websiteBuilderEditor.ADD_PAGE",
  DELETE_PAGE: "websiteBuilderEditor.DELETE_PAGE",
  RENAME_PAGE: "websiteBuilderEditor.RENAME_PAGE",
  SET_HOME_PAGE: "websiteBuilderEditor.SET_HOME_PAGE",
  REORDER_NAVIGATION_MENU_ITEMS: "websiteBuilderEditor.REORDER_NAVIGATION_MENU_ITEMS",
  UPDATE_NAVIGATION_MENU_ITEM: "websiteBuilderEditor.UPDATE_NAVIGATION_MENU_ITEM",
  ADD_NAVIGATION_MENU_ITEM: "websiteBuilderEditor.ADD_NAVIGATION_MENU_ITEM",
  DELETE_NAVIGATION_MENU_ITEM: "websiteBuilderEditor.DELETE_NAVIGATION_MENU_ITEM",
  SELECT_THEME: "websiteBuilderEditor.SELECT_THEME",
  UPDATE_GLOBAL_STYLES: "websiteBuilderEditor.UPDATE_SCOPED_STYLES",
  ADD_ICON_ASSETS: "websiteBuilderEditor.ADD_ICON_ASSETS",
  POST_MEDIA_ITEM: "websiteBuilderEditor.POST_MEDIA_ITEM",
  ARCHIVE_MEDIA_ITEM: "websiteBuilderEditor.ARCHIVE_MEDIA_ITEM",
  RESTORE_MEDIA_ITEM: "websiteBuilderEditor.RESTORE_MEDIA_ITEM",
  ADD_FORM: "websiteBuilderEditor.ADD_FORM",
  ARCHIVE_FORM: "websiteBuilderEditor.ARCHIVE_FORM",
  UPDATE_FORM: "websiteBuilderEditor.UPDATE_FORM",
  UPDATE_FORM_NAME: "websiteBuilderEditor.UPDATE_FORM_NAME",
  SELECT_NODE: "websiteBuilderEditor.SELECT_NODE",
  UPDATE_SELECTED_NODE: "websiteBuilderEditor.UPDATE_SELECTED_NODE",
  UNDO: "websiteBuilderEditor.UNDO",
  REDO: "websiteBuilderEditor.REDO",
  ADD_NODE: "websiteBuilderEditor.ADD_NODE",
  DELETE_NODE: "websiteBuilderEditor.DELETE_NODE",
  SET_HIDEABLE_NODE_VISIBILITY: "websiteBuilderEditor.SET_HIDEABLE_NODE_VISIBILITY",
  MOVE_ELEMENT: "websiteBuilderEditor.MOVE_ELEMENT",
  RESIZE_ELEMENT: "websiteBuilderEditor.RESIZE_ELEMENT",
  BRING_TO_FRONT_ELEMENT: "websiteBuilderEditor.BRING_TO_FRONT_ELEMENT",
  BRING_TO_BACK_ELEMENT: "websiteBuilderEditor.BRING_TO_BACK_ELEMENT",
  UPDATE_ELEMENT_SETTINGS: "websiteBuilderEditor.UPDATE_ELEMENT_SETTINGS",
  UPDATE_ELEMENT_STRETCH: "websiteBuilderEditor.UPDATE_ELEMENT_STRETCH",
  MOVE_CONTAINER: "websiteBuilderEditor.MOVE_CONTAINER",
  RESIZE_CONTAINER: "websiteBuilderEditor.RESIZE_CONTAINER",
  BRING_TO_FRONT_CONTAINER: "websiteBuilderEditor.BRING_TO_FRONT_CONTAINER",
  BRING_TO_BACK_CONTAINER: "websiteBuilderEditor.BRING_TO_BACK_CONTAINER",
  UPDATE_CONTAINER_SETTINGS: "websiteBuilderEditor.UPDATE_CONTAINER_SETTINGS",
  UPDATE_CONTAINER_STRETCH: "websiteBuilderEditor.UPDATE_CONTAINER_STRETCH",
  UPDATE_GRID_DIMENSIONS: "websiteBuilderEditor.UPDATE_GRID_DIMENSIONS",
  SWAP_FLEX_CHILD: "websiteBuilderEditor.SWAP_FLEX_CHILD",
  SWAP_GRID_CELL_CONTENT: "websiteBuilderEditor.SWAP_GRID_CELL_CONTENT",
  ADD_TAB: "websiteBuilderEditor.ADD_TAB",
  DELETE_TAB: "websiteBuilderEditor.DELETE_TAB",
  SWAP_TAB: "websiteBuilderEditor.SWAP_TAB",
  UPDATE_TAB_SETTINGS: "websiteBuilderEditor.UPDATE_TAB_SETTINGS",
  MOVE_SECTION: "websiteBuilderEditor.MOVE_SECTION",
  RESIZE_SECTION: "websiteBuilderEditor.RESIZE_SECTION",
  UPDATE_SECTION_BACKGROUND: "websiteBuilderEditor.UPDATE_SECTION_BACKGROUND",
  UPDATE_HEADER: "websiteBuilderEditor.UPDATE_HEADER",
} as const;

type TWebsiteBuilderEditorSystemAction =
  | IStartLoadingEditorAction
  | ILoadEditorAction
  | IExitEditorAction
  | ISetFatalErrorAction
  | IUpdateAutoSaveStatusStateAction
  | ISetDeviceViewAction
  | ISetModeAction
  | IPublishWebsiteVersionAction
  | IRestoreWebsiteVersionAction
  | ISelectPageAction
  | IAddPageAction
  | IDeletePageAction
  | IRenamePageAction
  | ISetHomePageAction
  | IReorderNavigationMenuItemsAction
  | IUpdateNavigationMenuItemAction
  | IAddNavigationMenuItemAction
  | IDeleteNavigationMenuItemAction
  | ISelectThemeAction
  | IUpdateGlobalStylesAction
  | IAddIconAssetsAction
  | IPostMediaItemAction
  | IArchiveMediaItemAction
  | IRestoreMediaItemAction
  | IAddFormAction
  | IArchiveFormAction
  | IUpdateFormAction
  | IUpdateFormNameAction
  | ISelectNodeAction
  | IUpdateSelectedNodeAction;

export interface IWebsiteBuilderEditorHistoryActionBase {
  pageId: number;
  device: TWebsiteBuilderDevice;
  scrollNodeId: string;
}

export type TWebsiteBuilderEditorHistoryAction =
  | IUndoAction
  | IRedoAction
  | IAddNodeAction
  | IDeleteNodeAction
  | ISetHideableNodeVisibilityAction
  | IMoveElementAction
  | IResizeElementAction
  | IBringToFrontElementAction
  | IBringToBackElementAction
  | IUpdateElementSettingsAction
  | IUpdateElementStretchAction
  | IMoveContainerAction
  | IResizeContainerAction
  | IBringToFrontContainerAction
  | IBringToBackContainerAction
  | IUpdateContainerSettingsAction
  | IUpdateContainerStretchAction
  | IUpdateGridDimensionsAction
  | ISwapFlexChildAction
  | ISwapGridCellContentAction
  | IAddTabAction
  | IDeleteTabAction
  | ISwapTabAction
  | IUpdateTabSettingsAction
  | IMoveSectionAction
  | IResizeSectionAction
  | IUpdateSectionBackgroundAction
  | IUpdateHeaderAction;

export type TWebsiteBuilderEditorAction = TWebsiteBuilderEditorSystemAction | TWebsiteBuilderEditorHistoryAction;

export interface IWebsiteBuilderHistorySnapshot {
  header: IWebsiteBuilderHeader;
  root: IWebsiteBuilderRoot;
  footer: IWebsiteBuilderFooter;
}

type TWebsiteBuilderHistoryUpdate = Pick<IWebsiteBuilderEditor, "header" | "pages" | "footer">;

const allowedEditorActionTypes = new Set<string>(Object.values(WebsiteBuilderEditorActionType));

export function isWebsiteBuilderEditorAction(action: AnyAction): action is TWebsiteBuilderEditorAction {
  return typeof action.type === "string" && allowedEditorActionTypes.has(action.type);
}

export function isWebsiteBuilderEditorHistoryAction(action: AnyAction): action is TWebsiteBuilderEditorHistoryAction {
  switch (action.type) {
    case WebsiteBuilderEditorActionType.UNDO:
    case WebsiteBuilderEditorActionType.REDO:
    case WebsiteBuilderEditorActionType.ADD_NODE:
    case WebsiteBuilderEditorActionType.DELETE_NODE:
    case WebsiteBuilderEditorActionType.SET_HIDEABLE_NODE_VISIBILITY:
    case WebsiteBuilderEditorActionType.MOVE_ELEMENT:
    case WebsiteBuilderEditorActionType.RESIZE_ELEMENT:
    case WebsiteBuilderEditorActionType.BRING_TO_FRONT_ELEMENT:
    case WebsiteBuilderEditorActionType.BRING_TO_BACK_ELEMENT:
    case WebsiteBuilderEditorActionType.UPDATE_ELEMENT_SETTINGS:
    case WebsiteBuilderEditorActionType.UPDATE_ELEMENT_STRETCH:
    case WebsiteBuilderEditorActionType.MOVE_CONTAINER:
    case WebsiteBuilderEditorActionType.RESIZE_CONTAINER:
    case WebsiteBuilderEditorActionType.BRING_TO_FRONT_CONTAINER:
    case WebsiteBuilderEditorActionType.BRING_TO_BACK_CONTAINER:
    case WebsiteBuilderEditorActionType.UPDATE_CONTAINER_SETTINGS:
    case WebsiteBuilderEditorActionType.UPDATE_CONTAINER_STRETCH:
    case WebsiteBuilderEditorActionType.UPDATE_GRID_DIMENSIONS:
    case WebsiteBuilderEditorActionType.SWAP_FLEX_CHILD:
    case WebsiteBuilderEditorActionType.SWAP_GRID_CELL_CONTENT:
    case WebsiteBuilderEditorActionType.ADD_TAB:
    case WebsiteBuilderEditorActionType.DELETE_TAB:
    case WebsiteBuilderEditorActionType.SWAP_TAB:
    case WebsiteBuilderEditorActionType.UPDATE_TAB_SETTINGS:
    case WebsiteBuilderEditorActionType.MOVE_SECTION:
    case WebsiteBuilderEditorActionType.RESIZE_SECTION:
    case WebsiteBuilderEditorActionType.UPDATE_SECTION_BACKGROUND:
    case WebsiteBuilderEditorActionType.UPDATE_HEADER:
      return true;
    default:
      return false;
  }
}

export function applyHistoryChange(
  header: IWebsiteBuilderHeader,
  root: IWebsiteBuilderRoot,
  footer: IWebsiteBuilderFooter,
  pages: TWebsiteBuilderWebsiteVersionPage[],
  activePageId: number,
  action: TWebsiteBuilderEditorHistoryAction,
): TWebsiteBuilderHistoryUpdate {
  function getHistorySnapshot(): IWebsiteBuilderHistorySnapshot {
    switch (action.type) {
      case WebsiteBuilderEditorActionType.ADD_NODE:
        return applyAddNodeChange(header, root, footer, action);
      case WebsiteBuilderEditorActionType.DELETE_NODE:
        return applyDeleteNodeChange(header, root, footer, action);
      case WebsiteBuilderEditorActionType.SET_HIDEABLE_NODE_VISIBILITY:
        return applySetHideableNodeVisibilityChange(header, root, footer, action);
      case WebsiteBuilderEditorActionType.MOVE_ELEMENT:
        return applyMoveElementChange(header, root, footer, action);
      case WebsiteBuilderEditorActionType.RESIZE_ELEMENT:
        return applyResizeElementChange(header, root, footer, action);
      case WebsiteBuilderEditorActionType.BRING_TO_FRONT_ELEMENT:
        return applyBringToFrontElementChange(header, root, footer, action);
      case WebsiteBuilderEditorActionType.BRING_TO_BACK_ELEMENT:
        return applyBringToBackElementChange(header, root, footer, action);
      case WebsiteBuilderEditorActionType.UPDATE_ELEMENT_SETTINGS:
        return applyUpdateElementSettingsChange(header, root, footer, action);
      case WebsiteBuilderEditorActionType.UPDATE_ELEMENT_STRETCH:
        return applyUpdateElementStretchChange(header, root, footer, action);
      case WebsiteBuilderEditorActionType.MOVE_CONTAINER:
        return applyMoveContainerChange(header, root, footer, action);
      case WebsiteBuilderEditorActionType.RESIZE_CONTAINER:
        return applyResizeContainerChange(header, root, footer, action);
      case WebsiteBuilderEditorActionType.BRING_TO_FRONT_CONTAINER:
        return applyBringToFrontContainerChange(header, root, footer, action);
      case WebsiteBuilderEditorActionType.BRING_TO_BACK_CONTAINER:
        return applyBringToBackContainerChange(header, root, footer, action);
      case WebsiteBuilderEditorActionType.UPDATE_CONTAINER_SETTINGS:
        return applyUpdateContainerSettingsChange(header, root, footer, action);
      case WebsiteBuilderEditorActionType.UPDATE_CONTAINER_STRETCH:
        return applyUpdateContainerStretchChange(header, root, footer, action);
      case WebsiteBuilderEditorActionType.UPDATE_GRID_DIMENSIONS:
        return applyUpdateGridDimensionsChange(header, root, footer, action);
      case WebsiteBuilderEditorActionType.SWAP_FLEX_CHILD:
        return applySwapFlexChildChange(header, root, footer, action);
      case WebsiteBuilderEditorActionType.SWAP_GRID_CELL_CONTENT:
        return applySwapGridCellContentChange(header, root, footer, action);
      case WebsiteBuilderEditorActionType.ADD_TAB:
        return applyAddTabChange(header, root, footer, action);
      case WebsiteBuilderEditorActionType.DELETE_TAB:
        return applyDeleteTabChange(header, root, footer, action);
      case WebsiteBuilderEditorActionType.SWAP_TAB:
        return applySwapTabChange(header, root, footer, action);
      case WebsiteBuilderEditorActionType.UPDATE_TAB_SETTINGS:
        return applyUpdateTabSettingsChange(header, root, footer, action);
      case WebsiteBuilderEditorActionType.MOVE_SECTION:
        return applyMoveSectionChange(header, root, footer, action);
      case WebsiteBuilderEditorActionType.RESIZE_SECTION:
        return applyResizeSectionChange(header, root, footer, action);
      case WebsiteBuilderEditorActionType.UPDATE_SECTION_BACKGROUND:
        return applyUpdateSectionBackgroundChange(header, root, footer, action);
      case WebsiteBuilderEditorActionType.UPDATE_HEADER:
        return applyUpdateHeaderChange(header, root, footer, action);
      default:
        return { header, root, footer };
    }
  }

  const historySnapshot = getHistorySnapshot();

  const historyUpdate: TWebsiteBuilderHistoryUpdate = {
    header: historySnapshot.header,
    pages: pages.map(page => {
      if (page.id === activePageId) {
        return {
          ...page,
          root: historySnapshot.root,
        };
      } else {
        return page;
      }
    }),
    footer: historySnapshot.footer,
  };

  return historyUpdate;
}

export function getInverseHistoryAction(action: TWebsiteBuilderEditorHistoryAction): TWebsiteBuilderEditorHistoryAction {
  switch (action.type) {
    case WebsiteBuilderEditorActionType.ADD_NODE:
      return getAddNodeInverseAction(action);
    case WebsiteBuilderEditorActionType.DELETE_NODE:
      return getDeleteNodeInverseAction(action);
    case WebsiteBuilderEditorActionType.SET_HIDEABLE_NODE_VISIBILITY:
      return getSetHideableNodeVisibilityInverseAction(action);
    case WebsiteBuilderEditorActionType.MOVE_ELEMENT:
      return getMoveElementInverseAction(action);
    case WebsiteBuilderEditorActionType.RESIZE_ELEMENT:
      return getResizeElementInverseAction(action);
    case WebsiteBuilderEditorActionType.BRING_TO_FRONT_ELEMENT:
      return getBringToFrontElementInverseAction(action);
    case WebsiteBuilderEditorActionType.BRING_TO_BACK_ELEMENT:
      return getBringToBackElementInverseAction(action);
    case WebsiteBuilderEditorActionType.UPDATE_ELEMENT_SETTINGS:
      return getUpdateElementSettingsInverseAction(action);
    case WebsiteBuilderEditorActionType.UPDATE_ELEMENT_STRETCH:
      return getUpdateElementStretchInverseAction(action);
    case WebsiteBuilderEditorActionType.MOVE_CONTAINER:
      return getMoveContainerInverseAction(action);
    case WebsiteBuilderEditorActionType.RESIZE_CONTAINER:
      return getResizeContainerInverseAction(action);
    case WebsiteBuilderEditorActionType.BRING_TO_FRONT_CONTAINER:
      return getBringToFrontContainerInverseAction(action);
    case WebsiteBuilderEditorActionType.BRING_TO_BACK_CONTAINER:
      return getBringToBackContainerInverseAction(action);
    case WebsiteBuilderEditorActionType.UPDATE_CONTAINER_SETTINGS:
      return getUpdateContainerSettingsInverseAction(action);
    case WebsiteBuilderEditorActionType.UPDATE_CONTAINER_STRETCH:
      return getUpdateContainerStretchInverseAction(action);
    case WebsiteBuilderEditorActionType.UPDATE_GRID_DIMENSIONS:
      return getUpdateGridDimensionsInverseAction(action);
    case WebsiteBuilderEditorActionType.SWAP_FLEX_CHILD:
      return getSwapFlexChildInverseAction(action);
    case WebsiteBuilderEditorActionType.SWAP_GRID_CELL_CONTENT:
      return getSwapGridCellContentInverseAction(action);
    case WebsiteBuilderEditorActionType.ADD_TAB:
      return getAddTabInverseAction(action);
    case WebsiteBuilderEditorActionType.DELETE_TAB:
      return getDeleteTabInverseAction(action);
    case WebsiteBuilderEditorActionType.SWAP_TAB:
      return getSwapTabInverseAction(action);
    case WebsiteBuilderEditorActionType.UPDATE_TAB_SETTINGS:
      return getUpdateTabSettingsInverseAction(action);
    case WebsiteBuilderEditorActionType.MOVE_SECTION:
      return getMoveSectionInverseAction(action);
    case WebsiteBuilderEditorActionType.RESIZE_SECTION:
      return getResizeSectionInverseAction(action);
    case WebsiteBuilderEditorActionType.UPDATE_SECTION_BACKGROUND:
      return getUpdateSectionBackgroundInverseAction(action);
    case WebsiteBuilderEditorActionType.UPDATE_HEADER:
      return getUpdateHeaderInverseAction(action);
    default:
      return null;
  }
}

export function applyUndoHistoryChange(
  header: IWebsiteBuilderHeader,
  root: IWebsiteBuilderRoot,
  footer: IWebsiteBuilderFooter,
  pages: TWebsiteBuilderWebsiteVersionPage[],
  activePageId: number,
  action: TWebsiteBuilderEditorHistoryAction,
): TWebsiteBuilderHistoryUpdate {
  const inverseAction = getInverseHistoryAction(action);

  if (inverseAction) {
    return applyHistoryChange(header, root, footer, pages, activePageId, inverseAction);
  } else {
    return { header, pages, footer };
  }
}